module.exports = __webpack_public_path__ + "placa_infor_10x_s_1x9_carne.png?3b3043c4648df9db6a37cf3dff9495a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_infor_10x_s_1x9_carne.png
// module id = 123
// module chunks = 0